import useAxios from "../../hooks/useAxios";

const usePrismCalendarNoteService = () => {
  const axiosNotes = useAxios();
  const axiosCreateNote = useAxios();
  const axiosUpdateNote = useAxios();
  const axiosDeleteNote = useAxios();

  const getCalendarNotes = async () => {
    return await axiosNotes.fetchData({
      url: "/prism/calendar-notes",
      method: "GET",
    });
  };

  const createCalendarNote = async (data) => {
    return await axiosCreateNote.fetchData({
      url: "/prism/calendar-notes",
      method: "POST",
      data,
    });
  };

  const updateCalendarNote = async (id, data) => {
    return await axiosUpdateNote.fetchData({
      url: `/prism/calendar-notes/${id}`,
      method: "PUT",
      data,
    });
  };

  const deleteCalendarNote = async (id) => {
    return await axiosDeleteNote.fetchData({
      url: `/prism/calendar-notes/${id}`,
      method: "DELETE",
    });
  };

  return {
    getCalendarNotes,
    calendarNoteLoading: axiosNotes.loading,
    calendarNoteResponse: axiosNotes.response,
    calendarNoteError: axiosNotes.error,
    createCalendarNote,
    createCalendarNoteLoading: axiosCreateNote.loading,
    updateCalendarNote,
    updateCalendarNoteLoading: axiosUpdateNote.loading,
    deleteCalendarNote,
    deleteCalendarNoteLoading: axiosDeleteNote.loading,
  };
};

export default usePrismCalendarNoteService;
